export const REGION = "asia-southeast1";
// local
export const LOCAL_USER = "Local User";
// firebase ref
export const REF = {
  USER: "user",
  BRANCH: "branch",
  OWNER: "owner",
  SHOP: "shop",
  STAFF: "staff",
  PAYMENT: "payment",
  ACCESS: "access",
  VOUCHER_PACKAGE: "voucherPackage",
  VOUCHER: "voucher",
  REDEEM: "redeem",
  MEDIA: "media",
  REQUEST: "request",
  ROSTER: "roster",
  LOCK_ROSTER: "lockRoster",
  TIME_TRACKING: "checkInOut",
  CASHUP: "cashUp",
  INCOME_STAFF: "incomeStaff",
  CREDIT_NOTES: "creditNotes",
  CREDIT_NOTES_REDEEM: "creditNotesRedeem",
  REFUND: "refund",
  GROUP: "group",
  SERVICE: "service",
  CHECK_IN_OUT: "checkInOut",
  DISCOUNT: "discount",
  JOB: "job",
  INCOME_STAFF_DETAIL: "incomeStaffDetail",
  PAYOUT_SETTING: "payoutSetting",
  PAYRATE_SETTING: "payrateSetting",
  PAYOUT_DAILY: "payoutDaily",
  PAYOUT_STATUS: "payoutStatus",
  PAYOUT_HISTORY: "payoutHistory",
};
